import { createContext } from 'react'

import type { IdTokenClaims, TokenSet } from './oidc'

export type AuthStatus = 'initialising' | 'authenticated' | 'unauthenticated' | 'error'

export interface AuthContextValue {
  status: AuthStatus
  /** False when VITE_KEYCLOAK_ISSUER / VITE_KEYCLOAK_CLIENT_ID are missing. */
  configured: boolean
  /** Display-only claims from the ID token. */
  claims: IdTokenClaims | undefined
  /** Populated when `status === 'error'`. */
  error: string | undefined
  /** Starts the Authorization Code + PKCE redirect. */
  login: (returnTo?: string) => void
  /** Ends the Keycloak session and returns to the post-logout URI. */
  logout: () => void
  /** Returns a valid access token, refreshing when needed. */
  getAccessToken: (forceRefresh: boolean) => Promise<string | undefined>
  /** Called by the OIDC callback screen once the code exchange succeeds. */
  acceptTokens: (tokens: TokenSet) => void
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined)
